import { TextFieldTheme, TextField as TPATextField } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React, { useCallback, useRef } from 'react';
import { useFocusFieldEvent } from '../../contexts/events-context';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { useFieldAttributes } from '../../sdk/components';
import { FieldDescriptionWUT, FieldErrorWUT, FieldLabelWUT } from '../../sdk/components-wut';
import { useInvokeCallback } from '../shared/use-invoke-callback';
import { classes } from './url-input-field-wut.st.css';
export const UrlInputFieldWUT = ({ id, target, value, required, label, hideLabel, disabled, readOnly, placeholder, onChange, onFocus, onBlur, description, error, hasError = false, errorMessage, FieldLayout, requiredIndicatorType, requiredIndicatorPlacement })=>{
    const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
    const invokeBlur = useInvokeCallback(onBlur);
    const inputRef = useRef(null);
    useFocusFieldEvent(()=>{
        inputRef.current?.focus({
            preventScroll: true
        });
    }, id);
    const handleBlur = useCallback(()=>{
        let updatedValue = '';
        if (value) {
            const urlWithoutProtocol = String(value).replace(/^https?:\/\//, '');
            updatedValue = `https://${urlWithoutProtocol}`;
        }
        onChange(updatedValue);
        invokeBlur();
    }, [
        value,
        onChange,
        invokeBlur
    ]);
    const handleUrlChange = useCallback((event)=>{
        const newValue = event.target.value;
        onChange(newValue);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                htmlFor: inputId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement
            }),
        renderInput: ()=>/*#__PURE__*/ React.createElement(TPATextField, {
                id: inputId,
                type: "url",
                error: hasError,
                newErrorMessage: true,
                value: value ? String(value) : '',
                className: classNames(classes.textField, classes.theme, {
                    [classes.error]: hasError,
                    [classes.hover]: forcedHover
                }),
                onChange: handleUrlChange,
                required: required,
                disabled: disabled,
                readOnly: readOnly,
                placeholder: placeholder,
                onBlur: handleBlur,
                onFocus: onFocus,
                "aria-label": label,
                theme: TextFieldTheme.Box,
                "aria-describedby": ariaDescribedBy,
                "aria-invalid": hasError,
                ref: inputRef
            }),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: hasError,
                errorMessage: errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }))
    });
};

//# sourceMappingURL=url-input-field-wut.js.map